<template>
  <Drawer
    v-loading="loading"
    :drawer="drawer"
    :size="870"
    :customTitle="true"
    :withHeader="true"
    :isShowFooter="false"
    :show-close="true"
    @close="close">
    <template slot="title">
      <span class="title">
        <span v-if="!isCheck" :class="{ acitve: acitve === 0 }" @click="acitve = 0">修改发票</span>
        <span :class="{ acitve: acitve === 1 }" @click.stop="(acitve = 1), changeLog(historyList[0])">历史记录</span>
        <span :class="{ acitve: acitve === 2 }" @click.stop="(acitve = 2), changeFeeBackLog()">反馈记录</span>

        <span v-if="rowData.reviewFeedback">
          <el-popover placement="top-start" width="auto" trigger="hover">
            <pre>{{ rowData.reviewFeedback }}</pre>
            <el-button
              slot="reference"
              style="background: rgba(165, 90, 248, 0.1); color: #a55af8"
              icon="el-icon-chat-dot-round"
              size="medium"
              round>最新反馈记录</el-button>
          </el-popover>
        </span>
        <span v-if="rowData.invoiceReviewType" class="ai-warning">
          <img src="@/assets/images/bill/red-warning.png" />
          客户期望税金 {{ rowData.minTax }}~ {{ rowData.maxTax }}USD
          <span class="ai-btn" @click="showAI">AI审单</span>
        </span>
      </span>
    </template>
    <div ref="lastContent" class="content">
      <InvoiceTable
        v-if="acitve === 0 || acitve === 3"
        :rowData="rowData"
        :mblType="mblType"
        :productList="productList"
        :isShowBack="false"
        :height="height - 150"
        :controlOverInvoicesId="controlOverInvoicesId"
        :isCoustomer="isCoustomer()"
        :isExamine="true"
        :StartValue="StartValue"
        :EndValue="EndValue"
        :isCheck="isCheck"
        @ok="invoiceOk"
        @close="close">
      </InvoiceTable>
      <div v-else-if="acitve === 1 && historyList?.length" class="history">
        <div class="lists">
          <div
            v-for="item in historyList"
            :key="item.id"
            class="panel"
            :class="{ active: item.id === historyActive }"
            @click="changeLog(item)">
            {{ formatDate(item.createdOn) }}
            {{ item.editSource !== 1 ? "客户" : "后台" }}修改
          </div>
        </div>
        <div class="history-contanier">
          <InvoiceTable
            :rowData="rowData"
            :mblType="mblType"
            :productList="historyItems"
            :isShowLock="false"
            :height="height - 150"
            :isShowBack="false"
            :isOpt="false"
            :controlOverInvoicesId="controlOverInvoicesId"
            :isCoustomer="isCoustomer()"
            @close="close"></InvoiceTable>
        </div>
      </div>
      <div v-else-if="acitve === 2 && feeBackList.length" class="history">
        <div class="lists">
          <div
            v-for="item in feeBackList"
            :key="item.id"
            class="panel"
            :class="{ active: item.id === feeBackItem.id }"
            @click="feeBackItem = item">
            {{ formatDate(item.createdOn) }}
            {{ item.source !== 1 ? "客户" : "后台" }}反馈
          </div>
        </div>
        <div class="feeBack-contanier">
          <div style="display: flex;">
            <div style="width: 45%; box-sizing: border-box; text-align: left;">
              <p>建议：</p>
              <p class="suggestion">{{ feeBackItem.message || "--" }}</p>
              <template v-if="feeBackItem.fileList?.length">
                <p>附件：</p>
                <div class="fileList">
                  <div v-for="(item, index) in feeBackItem.fileList" :key="index" class="file">
                    <img :src="imgUrl(item.fileName)" width="28" height="28" />
                    <p>{{ item.fileName }}</p>
                    <div class="opt">
                      <img src="@/assets/images/fdz.png" title="预览" @click="review(item)" />
                      <img src="@/assets/images/xz.png" title="下载" @click="download(item)" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div
              v-if="historyBackfeeBackItem.message"
              style="
                width: 45%;
                margin-left: 24px;
                box-sizing: border-box;
                text-align: left;
                color: red;
              ">
              <p>后台最新反馈记录：</p>
              <p class="suggestion">{{ historyBackfeeBackItem.message || "--" }}</p>
              <template v-if="historyBackfeeBackItem.fileList?.length">
                <p>附件：</p>
                <div class="fileList">
                  <div v-for="(item, index) in historyBackfeeBackItem.fileList" :key="index" class="file">
                    <img :src="imgUrl(item.fileName)" width="28" height="28" />
                    <p>{{ item.fileName }}</p>
                    <div class="opt">
                      <img src="@/assets/images/fdz.png" title="预览" @click="review(item)" />
                      <img src="@/assets/images/xz.png" title="下载" @click="download(item)" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <img v-else class="empty" src="@/assets/images/table/empty.webp" />
    </div>
    <AiInvoiceDialog :dialogVisible="dialogVisible" :rowData="rowData" :productList="productList" @cancel="dialogVisible = false" @ok="invoiceAiOk"></AiInvoiceDialog>
  </Drawer>
</template>

<script>
import Drawer from './Drawer1'
import InvoiceTable from '../table/InvoiceTableGGTCopy'
import AiInvoiceDialog from '../dialog/AiInvoiceDialog'
import {
  getLatestMBLProductDetail,
  getHistoryRecordList,
  getHistoryRecordDetailList,
  getInvoiceReviewRecordList
} from '@/api/bill'

export default {
  components: {
    Drawer,
    InvoiceTable,
    AiInvoiceDialog
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    mblType: {
      type: [Number, String],
      default: 0
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    isCheck: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acitve: 0,
      historyList: [],
      productList: [],
      historyActive: '',
      historyItems: [],
      RefuseReason: '',
      controlOverInvoicesId: 0,
      taxRefuseReasonlogVisible: false,
      // ✅ 关键：初始化为对象，避免 null
      feeBackItem: {},
      historyBackfeeBackItem: {},
      feeBackList: [],
      height: 0,
      loading: false,
      StartValue: 0,
      EndValue: 0,
      dialogVisible: false
    }
  },
  watch: {
    rowData: {
      handler(newValue) {
        this.rowData = newValue
        this.controlOverInvoicesId = newValue.id
      },
      immediate: true
    },
    drawer: {
      handler: async function(newValue) {
        if (newValue) {
          if (this.isCheck) {
            this.acitve = 1
          }
          this.$nextTick(() => {
            const viewDoc = document.querySelectorAll('.content')
            this.height = viewDoc[viewDoc.length - 1]?.offsetHeight || 600
          })
          if (!this.isCheck) {
            await this.getProductList()
          }
          await this.getHistoryList()
          if (this.isCheck && this.historyList.length) {
            this.changeLog(this.historyList[0])
          }
          this.getRefuseReason()
        }
      },
      immediate: true
    }
  },
  methods: {
    imgUrl(fileName) {
      const suffix = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase()
      const obj = {
        jpg: 'img',
        png: 'img',
        jpeg: 'img',
        pdf: 'pdf'
      }
      return require(`@/assets/images/file/${obj[suffix] || 'other'}.png`)
    },
    getRefuseReason() {
      // 暂未启用
    },
    async close() {
      this.acitve = 0
      this.taxRefuseReasonlogVisible = false
      this.$emit('close')
    },
    async getProductList() {
      this.loading = true
      try {
        const mblId = this.rowData.mblId || this.rowData.id
        const res = await getLatestMBLProductDetail(mblId)
        if (res.success) {
          this.productList = res.data.list.map((item) => ({
            ...item,
            isEdit: true,
            isAddRateExempt: !!item.batchNoExempt,
            isAddRateTwoExempt: !!item.batchNoTwoExempt,
            isAddRateThreeExempt: !!item.batchNoThreeExempt,
            isAddRateFourExempt: !!item.batchNoFourExempt,
            isAddRateFiveExempt: !!item.batchNoFiveExempt,
            isAddRateSixExempt: !!item.batchNoSixExempt,
            isAddRateSevenExempt: !!item.batchNoSevenExempt
          }))
          this.controlOverInvoicesId = this.rowData.id
        } else {
          this.$message.error(res.errorMessage || '获取产品列表失败')
        }
      } catch (error) {
        console.error('getProductList error:', error)
        this.$message.error('获取产品列表异常')
      } finally {
        this.loading = false
      }
    },
    async getHistoryList() {
      try {
        const mblId = this.rowData.mblId || this.rowData.id
        const res = await getHistoryRecordList(mblId)
        if (res.success) {
          this.historyList = res.data
          if (res.data.length) {
            this.historyActive = res.data[0].id
          }
        }
      } catch (error) {
        console.error('getHistoryList error:', error)
      }
    },
    async changeLog(item) {
      try {
        const res = await getHistoryRecordDetailList(item.id)
        if (res.success) {
          this.historyItems = res.data.map((i) => ({
            ...i,
            isAddRateExempt: !!i.batchNoExempt,
            isAddRateTwoExempt: !!i.batchNoTwoExempt,
            isAddRateThreeExempt: !!i.batchNoThreeExempt,
            isAddRateFourExempt: !!i.batchNoFourExempt,
            isAddRateFiveExempt: !!i.batchNoFiveExempt,
            isAddRateSixExempt: !!i.batchNoSixExempt,
            isAddRateSevenExempt: !!i.batchNoSevenExempt
          }))
          this.historyActive = item.id
        }
      } catch (error) {
        console.error('changeLog error:', error)
      }
    },
    isCoustomer() {
      const record = this.historyList.find(a => a.id === this.historyActive)
      return record ? record.editSource !== 1 : true
    },
    async changeFeeBackLog() {
      try {
        const mblId = this.rowData.mblId || this.rowData.id
        const res = await getInvoiceReviewRecordList(mblId)
        if (res.success) {
          this.feeBackList = res.data
          this.feeBackItem = res.data[0] || {}

          // ✅ 提取最新的 source=1（后台）反馈，若无则为空对象
          const backendFeedbacks = res.data.filter(item => item.source === 1)
          this.historyBackfeeBackItem = backendFeedbacks.length
            ? backendFeedbacks.reduce((prev, curr) =>
              new Date(curr.createdOn) > new Date(prev.createdOn) ? curr : prev
            )
            : {}
        }
      } catch (error) {
        console.error('changeFeeBackLog error:', error)
        this.feeBackItem = {}
        this.historyBackfeeBackItem = {}
      }
    },
    formatDate(date) {
      return date?.substring(0, 16) || '--'
    },
    invoiceOk(item) {
      this.$emit('ok', item)
    },
    invoiceAiOk(list) {
      this.productList = list.map(item => {
        return {
          ...item,
          isEdit: true,
          dutyFormula: '',
          isSteelLicense: item.isSteelLicense || false
        }
      })
      this.dialogVisible = false
    },
    // ✅ 启用下载功能
    download(item) {
      const url = `/api/ControlOverInvoices/previewOrDownload?fileName=${encodeURIComponent(item.fileName)}&filePath=${encodeURIComponent(item.filePath)}&isLook=false`
      const link = document.createElement('a')
      link.href = url
      link.download = item.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    review(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: item.filePath
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          item.filePath
        )
      } else {
        this.$message.error('暂时只支持图片和PDF查看')
      }
    },
    showAI() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
/* ... 原有样式保持不变 ... */
.divider1 {
  margin: 0 0 0 0;
}

:deep(.el-drawer__header) {
  height: 50px;
  padding-top: 0;
  padding-left: 6px;
  padding-bottom: 0;
  margin: 0;
  border-bottom: 1px solid #e9ecf3;
  box-sizing: border-box;
}

.title {
  width: 64px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.title span {
  color: #77879e !important;
  cursor: pointer;
}

.title span+span {
  margin-left: 20px;
}

.title .acitve {
  color: #142e79 !important;
}
.ai-warning {
  background: #FFEFE9;
  border-radius: 32px 32px 32px 32px;
  line-height: 25px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #FE453D;
  display: inline-block;
  padding-left: 12px;
  img {
    margin-top: 5px;
  }
  .ai-btn {
    background: #FE453D;
    width: 74px;
    text-align: center;
    display: inline-block;
    margin-left: 28px;
    border-radius: 32px 32px 32px 32px;
    color: #FFFFFF !important;
    cursor: pointer;
  }
}
.content {
  padding-top: 10;
  width: 100%;
  height: 98%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: auto;
}

.content .history {
  display: flex;
  width: 100%;
  height: 100%;
}

.content .history .lists {
  width: 155px;
  height: 100%;
  padding-top: 10px;
}

.content .history .lists .panel {
  padding-left: 2px;
  width: 155px;
  height: 40px;
  background: #f7f7f7;
  border-radius: 2px;
  margin: 0 auto;
  font-family: Microsoft YaHei;
  font-weight: 380;
  font-size: 12px;
  color: #333333;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.content .history .lists .panel+.panel {
  margin-top: 10px;
}

.content .history .lists .active {
  background: #142e79 !important;
  color: #ffffff !important;
}

.content .history .history-contanier {
  padding-left: 12px;
  width: calc(100% - 180px);
  height: 100%;
}

.content .history .feeBack-contanier {
  width: calc(100% - 236px);
  height: 100%;
  padding-left: 24px;
  box-sizing: border-box;
}

.content .history .feeBack-contanier .suggestion {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #657193;
  margin: 18px 0 50px;
  word-break: break-all;
  white-space: pre-line;
}

.content .history .feeBack-contanier .file {
  display: flex;
  align-items: center;
  width: 300px;
  height: 48px;
  background: #ffffff;
  border-radius: 6px;
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  box-shadow: 0 0 4px rgba(20, 46, 121, 0.2);
}

.content .history .feeBack-contanier .file>img {
  margin-right: 5px;
}

.content .history .feeBack-contanier .file p {
  width: calc(100% - 79px);
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.content .history .feeBack-contanier .file .opt {
  display: flex;
  justify-content: space-between;
  width: 46px;
}

.content .history .feeBack-contanier .file .opt img,
.content .history .feeBack-contanier .file .opt i {
  cursor: pointer;
  font-size: 18px;
  color: #142e79;
}

.empty {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 326px;
}
</style>

<style scoped>
.forecase-suggest-pop {
  width: auto !important;
  min-width: 0 !important;
  max-width: 500px !important;
}
</style>
